import { datadogRum } from '@datadog/browser-rum'

export const logError = (
  error: Error,
  context?: Record<string, unknown> | undefined,
): void => {
  console.warn(error, context) // note: this is `warn` and not `error` because DataDog will automatically grab anything sent to `console.error`
  datadogRum.addError(error, context)
}
